/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A high precision floating point value represented as a string */
  BigFloat: { input: any; output: any; }
  /** An arbitrary size integer represented as a string */
  BigInt: { input: any; output: any; }
  /** An opaque string using for tracking a position in results during pagination */
  Cursor: { input: any; output: any; }
  /** A date without time information */
  Date: { input: any; output: any; }
  /**
   * Implement the DateTime<Utc> scalar
   *
   * The input/output is a string in RFC3339 format.
   */
  DateTime: { input: any; output: any; }
  /** A date and time */
  Datetime: { input: any; output: any; }
  /** A Javascript Object Notation value serialized as a string */
  JSON: { input: any; output: any; }
  /** Any type not handled by the type system */
  Opaque: { input: any; output: any; }
  /** A time without date information */
  Time: { input: any; output: any; }
  /** A universally unique identifier */
  UUID: { input: any; output: any; }
};

export type AdminDebugData = {
  __typename?: 'AdminDebugData';
  appVarsPrivateKey: Scalars['String']['output'];
  appVarsPublicKey: Scalars['String']['output'];
  appVarsSecretPhrase: Scalars['String']['output'];
  applicationId: Scalars['Int']['output'];
  awsAccessKeyId: Scalars['String']['output'];
  awsRegion: Scalars['String']['output'];
  awsSecretAccessKey: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientPrivateKey: Scalars['String']['output'];
  clientPublicKey: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  dbListenerUrl: Scalars['String']['output'];
  dispatchActionOwner: Scalars['String']['output'];
  dispatchActionRepo: Scalars['String']['output'];
  dispatchActionToken: Scalars['String']['output'];
  githubInstallUrl: Scalars['String']['output'];
  githubOauthUrl: Scalars['String']['output'];
  siteUrl: Scalars['String']['output'];
  slackAppId: Scalars['String']['output'];
  slackClientId: Scalars['String']['output'];
  slackClientSecret: Scalars['String']['output'];
  slackSigningSecret: Scalars['String']['output'];
  stripePublicKey: Scalars['String']['output'];
  stripeSecretKey: Scalars['String']['output'];
  supabaseApiEndpoint: Scalars['String']['output'];
  supabaseGraphqlEndpoint: Scalars['String']['output'];
  supabaseJwtSecret: Scalars['String']['output'];
  supabaseProjectId: Scalars['String']['output'];
  supabasePublicKey: Scalars['String']['output'];
  supabaseSecretKey: Scalars['String']['output'];
  superAdmin: Scalars['String']['output'];
  webhookSecret: Scalars['String']['output'];
};

export type AicontextPreferences = {
  includeBaseVersion: Scalars['Boolean']['input'];
  includeCommitMessages: Scalars['Boolean']['input'];
  includeFileHistory: Scalars['Boolean']['input'];
  includeSurroundingCode: Scalars['Boolean']['input'];
};

export type AuditLogEntryType = {
  __typename?: 'AuditLogEntryType';
  details?: Maybe<Scalars['String']['output']>;
  event: Scalars['String']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LocationType>;
  status: EntryStatusType;
  timestamp: Scalars['DateTime']['output'];
};

export type AuditLogEntryTypeConnection = {
  __typename?: 'AuditLogEntryTypeConnection';
  /** A list of edges. */
  edges: Array<AuditLogEntryTypeEdge>;
  /** A list of nodes. */
  nodes: Array<AuditLogEntryType>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AuditLogEntryTypeEdge = {
  __typename?: 'AuditLogEntryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AuditLogEntryType;
};

/** Boolean expression comparing fields on type "BigFloat" */
export type BigFloatFilter = {
  eq?: InputMaybe<Scalars['BigFloat']['input']>;
  gt?: InputMaybe<Scalars['BigFloat']['input']>;
  gte?: InputMaybe<Scalars['BigFloat']['input']>;
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['BigFloat']['input']>;
  lte?: InputMaybe<Scalars['BigFloat']['input']>;
  neq?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Boolean expression comparing fields on type "BigFloatList" */
export type BigFloatListFilter = {
  containedBy?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  contains?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  eq?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** Boolean expression comparing fields on type "BigInt" */
export type BigIntFilter = {
  eq?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  neq?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Boolean expression comparing fields on type "BigIntList" */
export type BigIntListFilter = {
  containedBy?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  contains?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  eq?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type BillingAddress = {
  __typename?: 'BillingAddress';
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression comparing fields on type "Boolean" */
export type BooleanFilter = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  is?: InputMaybe<FilterIs>;
};

/** Boolean expression comparing fields on type "BooleanList" */
export type BooleanListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  contains?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  eq?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type CardDetails = {
  __typename?: 'CardDetails';
  brand: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  last4: Scalars['String']['output'];
};

/** Boolean expression comparing fields on type "Date" */
export type DateFilter = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
};

/** Boolean expression comparing fields on type "DateList" */
export type DateListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Date']['input']>>;
  contains?: InputMaybe<Array<Scalars['Date']['input']>>;
  eq?: InputMaybe<Array<Scalars['Date']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Date']['input']>>;
};

/** Boolean expression comparing fields on type "Datetime" */
export type DatetimeFilter = {
  eq?: InputMaybe<Scalars['Datetime']['input']>;
  gt?: InputMaybe<Scalars['Datetime']['input']>;
  gte?: InputMaybe<Scalars['Datetime']['input']>;
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Datetime']['input']>;
  lte?: InputMaybe<Scalars['Datetime']['input']>;
  neq?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Boolean expression comparing fields on type "DatetimeList" */
export type DatetimeListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  contains?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  eq?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

export enum EntryStatusType {
  Failure = 'FAILURE',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export enum FilterIs {
  NotNull = 'NOT_NULL',
  Null = 'NULL'
}

/** Boolean expression comparing fields on type "Float" */
export type FloatFilter = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
};

/** Boolean expression comparing fields on type "FloatList" */
export type FloatListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Float']['input']>>;
  contains?: InputMaybe<Array<Scalars['Float']['input']>>;
  eq?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type GithubRepository = {
  __typename?: 'GithubRepository';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultBranch?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fork?: Maybe<Scalars['Boolean']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  htmlUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  private?: Maybe<Scalars['Boolean']['output']>;
  pushedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Boolean expression comparing fields on type "ID" */
export type IdFilter = {
  eq?: InputMaybe<Scalars['ID']['input']>;
};

export type Installation = {
  __typename?: 'Installation';
  accessTokensUrl?: Maybe<Scalars['String']['output']>;
  account: Scalars['String']['output'];
  appId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  events: Array<Scalars['String']['output']>;
  htmlUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  repositoriesUrl?: Maybe<Scalars['String']['output']>;
  repositorySelection?: Maybe<Scalars['String']['output']>;
  singleFileName?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['Int']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Boolean expression comparing fields on type "Int" */
export type IntFilter = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
};

/** Boolean expression comparing fields on type "IntList" */
export type IntListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Int']['input']>>;
  contains?: InputMaybe<Array<Scalars['Int']['input']>>;
  eq?: InputMaybe<Array<Scalars['Int']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LocationType = {
  __typename?: 'LocationType';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type MergeResolution = {
  __typename?: 'MergeResolution';
  explanation: Scalars['String']['output'];
  resolved: Scalars['String']['output'];
};

export enum MergeStrategy {
  Balanced = 'BALANCED',
  Conservative = 'CONSERVATIVE',
  Progressive = 'PROGRESSIVE'
}

/** The root type for creating and mutating data */
export type Mutation = {
  __typename?: 'Mutation';
  addPaymentMethod: PaymentMethodDetails;
  applyResolution: Scalars['Boolean']['output'];
  /** Deletes zero or more records from the `notifications` collection */
  deleteFromnotificationsCollection: NotificationsDeleteResponse;
  /** Deletes zero or more records from the `obs_queue` collection */
  deleteFromobs_queueCollection: Obs_QueueDeleteResponse;
  /** Deletes zero or more records from the `pull_requests` collection */
  deleteFrompull_requestsCollection: Pull_RequestsDeleteResponse;
  /** Deletes zero or more records from the `pull_requests_by_provider` collection */
  deleteFrompull_requests_by_providerCollection: Pull_Requests_By_ProviderDeleteResponse;
  /** Deletes zero or more records from the `pull_requests_resolutions` collection */
  deleteFrompull_requests_resolutionsCollection: Pull_Requests_ResolutionsDeleteResponse;
  /** Deletes zero or more records from the `slack_connections` collection */
  deleteFromslack_connectionsCollection: Slack_ConnectionsDeleteResponse;
  /** Deletes zero or more records from the `users` collection */
  deleteFromusersCollection: UsersDeleteResponse;
  diesel_manage_updated_at?: Maybe<Scalars['Opaque']['output']>;
  gen_random_uuid?: Maybe<Scalars['UUID']['output']>;
  generate_uuid?: Maybe<Scalars['UUID']['output']>;
  /** Adds one or more `notifications` records to the collection */
  insertIntonotificationsCollection?: Maybe<NotificationsInsertResponse>;
  /** Adds one or more `obs_queue` records to the collection */
  insertIntoobs_queueCollection?: Maybe<Obs_QueueInsertResponse>;
  /** Adds one or more `pull_requests` records to the collection */
  insertIntopull_requestsCollection?: Maybe<Pull_RequestsInsertResponse>;
  /** Adds one or more `pull_requests_by_provider` records to the collection */
  insertIntopull_requests_by_providerCollection?: Maybe<Pull_Requests_By_ProviderInsertResponse>;
  /** Adds one or more `pull_requests_resolutions` records to the collection */
  insertIntopull_requests_resolutionsCollection?: Maybe<Pull_Requests_ResolutionsInsertResponse>;
  /** Adds one or more `slack_connections` records to the collection */
  insertIntoslack_connectionsCollection?: Maybe<Slack_ConnectionsInsertResponse>;
  /** Adds one or more `users` records to the collection */
  insertIntousersCollection?: Maybe<UsersInsertResponse>;
  merge_user_settings?: Maybe<Scalars['JSON']['output']>;
  pg_stat_statements_reset?: Maybe<Scalars['Opaque']['output']>;
  removePaymentMethod: PaymentMethodDetails;
  schedulePr: Scalars['Boolean']['output'];
  /** Updates zero or more records in the `notifications` collection */
  updatenotificationsCollection: NotificationsUpdateResponse;
  /** Updates zero or more records in the `obs_queue` collection */
  updateobs_queueCollection: Obs_QueueUpdateResponse;
  /** Updates zero or more records in the `pull_requests` collection */
  updatepull_requestsCollection: Pull_RequestsUpdateResponse;
  /** Updates zero or more records in the `pull_requests_by_provider` collection */
  updatepull_requests_by_providerCollection: Pull_Requests_By_ProviderUpdateResponse;
  /** Updates zero or more records in the `pull_requests_resolutions` collection */
  updatepull_requests_resolutionsCollection: Pull_Requests_ResolutionsUpdateResponse;
  /** Updates zero or more records in the `slack_connections` collection */
  updateslack_connectionsCollection: Slack_ConnectionsUpdateResponse;
  /** Updates zero or more records in the `users` collection */
  updateusersCollection: UsersUpdateResponse;
  uuid_generate_v1?: Maybe<Scalars['UUID']['output']>;
  uuid_generate_v1mc?: Maybe<Scalars['UUID']['output']>;
  uuid_generate_v4?: Maybe<Scalars['UUID']['output']>;
};


/** The root type for creating and mutating data */
export type MutationAddPaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationApplyResolutionArgs = {
  organizationId: Scalars['String']['input'];
  repoId: Scalars['String']['input'];
  resolutionId: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationDeleteFromnotificationsCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<NotificationsFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromobs_QueueCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<Obs_QueueFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFrompull_RequestsCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<Pull_RequestsFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFrompull_Requests_By_ProviderCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<Pull_Requests_By_ProviderFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFrompull_Requests_ResolutionsCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<Pull_Requests_ResolutionsFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromslack_ConnectionsCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<Slack_ConnectionsFilter>;
};


/** The root type for creating and mutating data */
export type MutationDeleteFromusersCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<UsersFilter>;
};


/** The root type for creating and mutating data */
export type MutationDiesel_Manage_Updated_AtArgs = {
  _tbl: Scalars['Opaque']['input'];
};


/** The root type for creating and mutating data */
export type MutationInsertIntonotificationsCollectionArgs = {
  objects: Array<NotificationsInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoobs_QueueCollectionArgs = {
  objects: Array<Obs_QueueInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntopull_RequestsCollectionArgs = {
  objects: Array<Pull_RequestsInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntopull_Requests_By_ProviderCollectionArgs = {
  objects: Array<Pull_Requests_By_ProviderInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntopull_Requests_ResolutionsCollectionArgs = {
  objects: Array<Pull_Requests_ResolutionsInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntoslack_ConnectionsCollectionArgs = {
  objects: Array<Slack_ConnectionsInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationInsertIntousersCollectionArgs = {
  objects: Array<UsersInsertInput>;
};


/** The root type for creating and mutating data */
export type MutationMerge_User_SettingsArgs = {
  id: Scalars['UUID']['input'];
  settings: Scalars['JSON']['input'];
};


/** The root type for creating and mutating data */
export type MutationPg_Stat_Statements_ResetArgs = {
  dbid?: InputMaybe<Scalars['Opaque']['input']>;
  queryid?: InputMaybe<Scalars['BigInt']['input']>;
  userid?: InputMaybe<Scalars['Opaque']['input']>;
};


/** The root type for creating and mutating data */
export type MutationRemovePaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationSchedulePrArgs = {
  ownerId: Scalars['String']['input'];
  pr: Scalars['Int']['input'];
  repoId: Scalars['String']['input'];
};


/** The root type for creating and mutating data */
export type MutationUpdatenotificationsCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<NotificationsFilter>;
  set: NotificationsUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateobs_QueueCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<Obs_QueueFilter>;
  set: Obs_QueueUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdatepull_RequestsCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<Pull_RequestsFilter>;
  set: Pull_RequestsUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdatepull_Requests_By_ProviderCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<Pull_Requests_By_ProviderFilter>;
  set: Pull_Requests_By_ProviderUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdatepull_Requests_ResolutionsCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<Pull_Requests_ResolutionsFilter>;
  set: Pull_Requests_ResolutionsUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateslack_ConnectionsCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<Slack_ConnectionsFilter>;
  set: Slack_ConnectionsUpdateInput;
};


/** The root type for creating and mutating data */
export type MutationUpdateusersCollectionArgs = {
  atMost?: Scalars['Int']['input'];
  filter?: InputMaybe<UsersFilter>;
  set: UsersUpdateInput;
};

export type Node = {
  /** Retrieves a record by `ID` */
  nodeId: Scalars['ID']['output'];
};

/** Boolean expression comparing fields on type "Opaque" */
export type OpaqueFilter = {
  eq?: InputMaybe<Scalars['Opaque']['input']>;
  is?: InputMaybe<FilterIs>;
};

/** Defines a per-field sorting order */
export enum OrderByDirection {
  /** Ascending order, nulls first */
  AscNullsFirst = 'AscNullsFirst',
  /** Ascending order, nulls last */
  AscNullsLast = 'AscNullsLast',
  /** Descending order, nulls first */
  DescNullsFirst = 'DescNullsFirst',
  /** Descending order, nulls last */
  DescNullsLast = 'DescNullsLast'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodDetails = {
  __typename?: 'PaymentMethodDetails';
  billing: BillingAddress;
  card: CardDetails;
  id: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  adminAuthorized: Scalars['Boolean']['output'];
  adminDebug: AdminDebugData;
  auditLogs: AuditLogEntryTypeConnection;
  coreOnline: Scalars['Boolean']['output'];
  generateOpenAiResolution: MergeResolution;
  get_db_listener_url?: Maybe<Scalars['String']['output']>;
  get_super_admin?: Maybe<Scalars['String']['output']>;
  listOpenAiModels: Array<Scalars['String']['output']>;
  listPaymentMethods: Array<PaymentMethodDetails>;
  /** Retrieve a record by its `ID` */
  node?: Maybe<Node>;
  /** A pagable collection of type `notifications` */
  notificationsCollection?: Maybe<NotificationsConnection>;
  /** A pagable collection of type `obs_queue` */
  obs_queueCollection?: Maybe<Obs_QueueConnection>;
  platformsListGithubInstallationRepositories: Array<GithubRepository>;
  platformsListGithubInstallations: Array<Installation>;
  /** A pagable collection of type `pull_requests` */
  pull_requestsCollection?: Maybe<Pull_RequestsConnection>;
  /** A pagable collection of type `pull_requests_by_provider` */
  pull_requests_by_providerCollection?: Maybe<Pull_Requests_By_ProviderConnection>;
  /** A pagable collection of type `pull_requests_resolutions` */
  pull_requests_resolutionsCollection?: Maybe<Pull_Requests_ResolutionsConnection>;
  /** A pagable collection of type `slack_connections` */
  slack_connectionsCollection?: Maybe<Slack_ConnectionsConnection>;
  status: SystemStatus;
  /** A pagable collection of type `users` */
  usersCollection?: Maybe<UsersConnection>;
  uuid_generate_v3?: Maybe<Scalars['UUID']['output']>;
  uuid_generate_v5?: Maybe<Scalars['UUID']['output']>;
  uuid_nil?: Maybe<Scalars['UUID']['output']>;
  uuid_ns_dns?: Maybe<Scalars['UUID']['output']>;
  uuid_ns_oid?: Maybe<Scalars['UUID']['output']>;
  uuid_ns_url?: Maybe<Scalars['UUID']['output']>;
  uuid_ns_x500?: Maybe<Scalars['UUID']['output']>;
  verifyOpenAiKeys: Scalars['Boolean']['output'];
};


export type QueryAuditLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGenerateOpenAiResolutionArgs = {
  contextPreferences: AicontextPreferences;
  fileIndex: Scalars['Int']['input'];
  maxTokens: Scalars['Int']['input'];
  mergeStrategy: MergeStrategy;
  model: Scalars['String']['input'];
  resolutionId: Scalars['UUID']['input'];
  temperature: Scalars['Float']['input'];
};


export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryNotificationsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<NotificationsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};


export type QueryObs_QueueCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Obs_QueueFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Obs_QueueOrderBy>>;
};


export type QueryPlatformsListGithubInstallationRepositoriesArgs = {
  installationId: Scalars['Int']['input'];
};


export type QueryPull_RequestsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Pull_RequestsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Pull_RequestsOrderBy>>;
};


export type QueryPull_Requests_By_ProviderCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Pull_Requests_By_ProviderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Pull_Requests_By_ProviderOrderBy>>;
};


export type QueryPull_Requests_ResolutionsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Pull_Requests_ResolutionsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Pull_Requests_ResolutionsOrderBy>>;
};


export type QuerySlack_ConnectionsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Slack_ConnectionsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Slack_ConnectionsOrderBy>>;
};


export type QueryUsersCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UsersFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type QueryUuid_Generate_V3Args = {
  name: Scalars['String']['input'];
  namespace: Scalars['UUID']['input'];
};


export type QueryUuid_Generate_V5Args = {
  name: Scalars['String']['input'];
  namespace: Scalars['UUID']['input'];
};

/** Boolean expression comparing fields on type "String" */
export type StringFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  iregex?: InputMaybe<Scalars['String']['input']>;
  is?: InputMaybe<FilterIs>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  regex?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression comparing fields on type "StringList" */
export type StringListFilter = {
  containedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  eq?: InputMaybe<Array<Scalars['String']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  integers: Scalars['Int']['output'];
};

export enum SystemStatus {
  Degraded = 'DEGRADED',
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

/** Boolean expression comparing fields on type "Time" */
export type TimeFilter = {
  eq?: InputMaybe<Scalars['Time']['input']>;
  gt?: InputMaybe<Scalars['Time']['input']>;
  gte?: InputMaybe<Scalars['Time']['input']>;
  in?: InputMaybe<Array<Scalars['Time']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Time']['input']>;
  lte?: InputMaybe<Scalars['Time']['input']>;
  neq?: InputMaybe<Scalars['Time']['input']>;
};

/** Boolean expression comparing fields on type "TimeList" */
export type TimeListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Time']['input']>>;
  contains?: InputMaybe<Array<Scalars['Time']['input']>>;
  eq?: InputMaybe<Array<Scalars['Time']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** Boolean expression comparing fields on type "UUID" */
export type UuidFilter = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
};

/** Boolean expression comparing fields on type "UUIDList" */
export type UuidListFilter = {
  containedBy?: InputMaybe<Array<Scalars['UUID']['input']>>;
  contains?: InputMaybe<Array<Scalars['UUID']['input']>>;
  eq?: InputMaybe<Array<Scalars['UUID']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export enum Config_Key {
  DbListenerUrl = 'db_listener_url',
  SuperAdmin = 'super_admin'
}

/** Boolean expression comparing fields on type "config_key" */
export type Config_KeyFilter = {
  eq?: InputMaybe<Config_Key>;
  in?: InputMaybe<Array<Config_Key>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Config_Key>;
};

export type Notifications = Node & {
  __typename?: 'notifications';
  created_at: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  payload: Scalars['JSON']['output'];
  unread: Scalars['Boolean']['output'];
  updated_at: Scalars['Datetime']['output'];
  user_id: Scalars['UUID']['output'];
  users?: Maybe<Users>;
};

export type NotificationsConnection = {
  __typename?: 'notificationsConnection';
  edges: Array<NotificationsEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars['Int']['output'];
};

export type NotificationsDeleteResponse = {
  __typename?: 'notificationsDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Notifications>;
};

export type NotificationsEdge = {
  __typename?: 'notificationsEdge';
  cursor: Scalars['String']['output'];
  node: Notifications;
};

export type NotificationsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<NotificationsFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<NotificationsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<NotificationsFilter>>;
  unread?: InputMaybe<BooleanFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type NotificationsInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Datetime']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type NotificationsInsertResponse = {
  __typename?: 'notificationsInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Notifications>;
};

export type NotificationsOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  unread?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type NotificationsUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['Datetime']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type NotificationsUpdateResponse = {
  __typename?: 'notificationsUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Notifications>;
};

export type Obs_Queue = Node & {
  __typename?: 'obs_queue';
  created_at?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  request_id: Scalars['String']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
  value: Scalars['JSON']['output'];
};

export type Obs_QueueConnection = {
  __typename?: 'obs_queueConnection';
  edges: Array<Obs_QueueEdge>;
  pageInfo: PageInfo;
};

export type Obs_QueueDeleteResponse = {
  __typename?: 'obs_queueDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Obs_Queue>;
};

export type Obs_QueueEdge = {
  __typename?: 'obs_queueEdge';
  cursor: Scalars['String']['output'];
  node: Obs_Queue;
};

export type Obs_QueueFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Obs_QueueFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Obs_QueueFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Obs_QueueFilter>>;
  request_id?: InputMaybe<StringFilter>;
};

export type Obs_QueueInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  request_id?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['JSON']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type Obs_QueueInsertResponse = {
  __typename?: 'obs_queueInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Obs_Queue>;
};

export type Obs_QueueOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  request_id?: InputMaybe<OrderByDirection>;
};

export type Obs_QueueUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  request_id?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['JSON']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type Obs_QueueUpdateResponse = {
  __typename?: 'obs_queueUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Obs_Queue>;
};

export type Pull_Requests = Node & {
  __typename?: 'pull_requests';
  created_at?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  mergeable_state?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  provider: Scalars['JSON']['output'];
  pull_requests_resolutionsCollection?: Maybe<Pull_Requests_ResolutionsConnection>;
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Datetime']['output']>;
};


export type Pull_RequestsPull_Requests_ResolutionsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Pull_Requests_ResolutionsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Pull_Requests_ResolutionsOrderBy>>;
};

export type Pull_RequestsConnection = {
  __typename?: 'pull_requestsConnection';
  edges: Array<Pull_RequestsEdge>;
  pageInfo: PageInfo;
};

export type Pull_RequestsDeleteResponse = {
  __typename?: 'pull_requestsDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Pull_Requests>;
};

export type Pull_RequestsEdge = {
  __typename?: 'pull_requestsEdge';
  cursor: Scalars['String']['output'];
  node: Pull_Requests;
};

export type Pull_RequestsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Pull_RequestsFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  mergeable_state?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Pull_RequestsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Pull_RequestsFilter>>;
  state?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Pull_RequestsInsertInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  mergeable_state?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  provider?: InputMaybe<Scalars['JSON']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['Datetime']['input']>;
};

export type Pull_RequestsInsertResponse = {
  __typename?: 'pull_requestsInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Pull_Requests>;
};

export type Pull_RequestsOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  mergeable_state?: InputMaybe<OrderByDirection>;
  state?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Pull_RequestsUpdateInput = {
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  mergeable_state?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  provider?: InputMaybe<Scalars['JSON']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['Datetime']['input']>;
};

export type Pull_RequestsUpdateResponse = {
  __typename?: 'pull_requestsUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Pull_Requests>;
};

export type Pull_Requests_By_Provider = Node & {
  __typename?: 'pull_requests_by_provider';
  id?: Maybe<Scalars['UUID']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  pr_number?: Maybe<Scalars['Int']['output']>;
  repo?: Maybe<Scalars['String']['output']>;
};

export type Pull_Requests_By_ProviderConnection = {
  __typename?: 'pull_requests_by_providerConnection';
  edges: Array<Pull_Requests_By_ProviderEdge>;
  pageInfo: PageInfo;
};

export type Pull_Requests_By_ProviderDeleteResponse = {
  __typename?: 'pull_requests_by_providerDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Pull_Requests_By_Provider>;
};

export type Pull_Requests_By_ProviderEdge = {
  __typename?: 'pull_requests_by_providerEdge';
  cursor: Scalars['String']['output'];
  node: Pull_Requests_By_Provider;
};

export type Pull_Requests_By_ProviderFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Pull_Requests_By_ProviderFilter>>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Pull_Requests_By_ProviderFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Pull_Requests_By_ProviderFilter>>;
  owner?: InputMaybe<StringFilter>;
  pr_number?: InputMaybe<IntFilter>;
  repo?: InputMaybe<StringFilter>;
};

export type Pull_Requests_By_ProviderInsertInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  pr_number?: InputMaybe<Scalars['Int']['input']>;
  repo?: InputMaybe<Scalars['String']['input']>;
};

export type Pull_Requests_By_ProviderInsertResponse = {
  __typename?: 'pull_requests_by_providerInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Pull_Requests_By_Provider>;
};

export type Pull_Requests_By_ProviderOrderBy = {
  id?: InputMaybe<OrderByDirection>;
  owner?: InputMaybe<OrderByDirection>;
  pr_number?: InputMaybe<OrderByDirection>;
  repo?: InputMaybe<OrderByDirection>;
};

export type Pull_Requests_By_ProviderUpdateInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  pr_number?: InputMaybe<Scalars['Int']['input']>;
  repo?: InputMaybe<Scalars['String']['input']>;
};

export type Pull_Requests_By_ProviderUpdateResponse = {
  __typename?: 'pull_requests_by_providerUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Pull_Requests_By_Provider>;
};

export type Pull_Requests_Resolutions = Node & {
  __typename?: 'pull_requests_resolutions';
  base_sha: Scalars['String']['output'];
  created_at?: Maybe<Scalars['Datetime']['output']>;
  hash_id: Scalars['UUID']['output'];
  head_sha: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  pull_request_id: Scalars['UUID']['output'];
  pull_requests?: Maybe<Pull_Requests>;
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Datetime']['output']>;
};

export type Pull_Requests_ResolutionsConnection = {
  __typename?: 'pull_requests_resolutionsConnection';
  edges: Array<Pull_Requests_ResolutionsEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars['Int']['output'];
};

export type Pull_Requests_ResolutionsDeleteResponse = {
  __typename?: 'pull_requests_resolutionsDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Pull_Requests_Resolutions>;
};

export type Pull_Requests_ResolutionsEdge = {
  __typename?: 'pull_requests_resolutionsEdge';
  cursor: Scalars['String']['output'];
  node: Pull_Requests_Resolutions;
};

export type Pull_Requests_ResolutionsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Pull_Requests_ResolutionsFilter>>;
  base_sha?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  hash_id?: InputMaybe<UuidFilter>;
  head_sha?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Pull_Requests_ResolutionsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Pull_Requests_ResolutionsFilter>>;
  pull_request_id?: InputMaybe<UuidFilter>;
  status?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Pull_Requests_ResolutionsInsertInput = {
  base_sha?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  hash_id?: InputMaybe<Scalars['UUID']['input']>;
  head_sha?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  pull_request_id?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['Datetime']['input']>;
};

export type Pull_Requests_ResolutionsInsertResponse = {
  __typename?: 'pull_requests_resolutionsInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Pull_Requests_Resolutions>;
};

export type Pull_Requests_ResolutionsOrderBy = {
  base_sha?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  hash_id?: InputMaybe<OrderByDirection>;
  head_sha?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  pull_request_id?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Pull_Requests_ResolutionsUpdateInput = {
  base_sha?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  hash_id?: InputMaybe<Scalars['UUID']['input']>;
  head_sha?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  pull_request_id?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['Datetime']['input']>;
};

export type Pull_Requests_ResolutionsUpdateResponse = {
  __typename?: 'pull_requests_resolutionsUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Pull_Requests_Resolutions>;
};

export type Slack_Connections = Node & {
  __typename?: 'slack_connections';
  bot_user_id: Scalars['String']['output'];
  installed_at?: Maybe<Scalars['Datetime']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  team_id: Scalars['String']['output'];
  team_name?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['UUID']['output'];
  users?: Maybe<Users>;
};

export type Slack_ConnectionsConnection = {
  __typename?: 'slack_connectionsConnection';
  edges: Array<Slack_ConnectionsEdge>;
  pageInfo: PageInfo;
};

export type Slack_ConnectionsDeleteResponse = {
  __typename?: 'slack_connectionsDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Slack_Connections>;
};

export type Slack_ConnectionsEdge = {
  __typename?: 'slack_connectionsEdge';
  cursor: Scalars['String']['output'];
  node: Slack_Connections;
};

export type Slack_ConnectionsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Slack_ConnectionsFilter>>;
  bot_user_id?: InputMaybe<StringFilter>;
  installed_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Slack_ConnectionsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Slack_ConnectionsFilter>>;
  team_id?: InputMaybe<StringFilter>;
  team_name?: InputMaybe<StringFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Slack_ConnectionsInsertInput = {
  bot_user_id?: InputMaybe<Scalars['String']['input']>;
  installed_at?: InputMaybe<Scalars['Datetime']['input']>;
  team_id?: InputMaybe<Scalars['String']['input']>;
  team_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type Slack_ConnectionsInsertResponse = {
  __typename?: 'slack_connectionsInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Slack_Connections>;
};

export type Slack_ConnectionsOrderBy = {
  bot_user_id?: InputMaybe<OrderByDirection>;
  installed_at?: InputMaybe<OrderByDirection>;
  team_id?: InputMaybe<OrderByDirection>;
  team_name?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Slack_ConnectionsUpdateInput = {
  bot_user_id?: InputMaybe<Scalars['String']['input']>;
  installed_at?: InputMaybe<Scalars['Datetime']['input']>;
  team_id?: InputMaybe<Scalars['String']['input']>;
  team_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['UUID']['input']>;
};

export type Slack_ConnectionsUpdateResponse = {
  __typename?: 'slack_connectionsUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Slack_Connections>;
};

export enum Status_Type {
  Active = 'active',
  Deleted = 'deleted',
  Inactive = 'inactive',
  Pending = 'pending'
}

/** Boolean expression comparing fields on type "status_type" */
export type Status_TypeFilter = {
  eq?: InputMaybe<Status_Type>;
  in?: InputMaybe<Array<Status_Type>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Status_Type>;
};

export enum User_Role {
  Admin = 'admin',
  Customer = 'customer',
  SuperAdmin = 'super_admin'
}

/** Boolean expression comparing fields on type "user_role" */
export type User_RoleFilter = {
  eq?: InputMaybe<User_Role>;
  in?: InputMaybe<Array<User_Role>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<User_Role>;
};

export type Users = Node & {
  __typename?: 'users';
  audit_logs?: Maybe<Scalars['Opaque']['output']>;
  auth_methods: Scalars['JSON']['output'];
  avatar_url?: Maybe<Scalars['String']['output']>;
  banned: Scalars['Boolean']['output'];
  created_at?: Maybe<Scalars['Datetime']['output']>;
  email_newsletter: Scalars['Boolean']['output'];
  email_notifications: Scalars['Boolean']['output'];
  emails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  first_name?: Maybe<Scalars['String']['output']>;
  followers?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['UUID']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars['ID']['output'];
  notificationsCollection?: Maybe<NotificationsConnection>;
  public_repos?: Maybe<Scalars['BigInt']['output']>;
  settings: Scalars['JSON']['output'];
  slack_connectionsCollection?: Maybe<Slack_ConnectionsConnection>;
  updated_at?: Maybe<Scalars['Datetime']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};


export type UsersNotificationsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<NotificationsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};


export type UsersSlack_ConnectionsCollectionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<Slack_ConnectionsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Slack_ConnectionsOrderBy>>;
};

export type UsersConnection = {
  __typename?: 'usersConnection';
  edges: Array<UsersEdge>;
  pageInfo: PageInfo;
};

export type UsersDeleteResponse = {
  __typename?: 'usersDeleteResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Users>;
};

export type UsersEdge = {
  __typename?: 'usersEdge';
  cursor: Scalars['String']['output'];
  node: Users;
};

export type UsersFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<UsersFilter>>;
  audit_logs?: InputMaybe<OpaqueFilter>;
  avatar_url?: InputMaybe<StringFilter>;
  banned?: InputMaybe<BooleanFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  email_newsletter?: InputMaybe<BooleanFilter>;
  email_notifications?: InputMaybe<BooleanFilter>;
  emails?: InputMaybe<StringListFilter>;
  first_name?: InputMaybe<StringFilter>;
  followers?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<UuidFilter>;
  last_name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<UsersFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<UsersFilter>>;
  public_repos?: InputMaybe<BigIntFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<StringFilter>;
};

export type UsersInsertInput = {
  audit_logs?: InputMaybe<Scalars['Opaque']['input']>;
  auth_methods?: InputMaybe<Scalars['JSON']['input']>;
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  banned?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  email_newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  email_notifications?: InputMaybe<Scalars['Boolean']['input']>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  public_repos?: InputMaybe<Scalars['BigInt']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  updated_at?: InputMaybe<Scalars['Datetime']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type UsersInsertResponse = {
  __typename?: 'usersInsertResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Users>;
};

export type UsersOrderBy = {
  audit_logs?: InputMaybe<OrderByDirection>;
  avatar_url?: InputMaybe<OrderByDirection>;
  banned?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  email_newsletter?: InputMaybe<OrderByDirection>;
  email_notifications?: InputMaybe<OrderByDirection>;
  first_name?: InputMaybe<OrderByDirection>;
  followers?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  last_name?: InputMaybe<OrderByDirection>;
  public_repos?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type UsersUpdateInput = {
  audit_logs?: InputMaybe<Scalars['Opaque']['input']>;
  auth_methods?: InputMaybe<Scalars['JSON']['input']>;
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  banned?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['Datetime']['input']>;
  email_newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  email_notifications?: InputMaybe<Scalars['Boolean']['input']>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  followers?: InputMaybe<Scalars['BigInt']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  public_repos?: InputMaybe<Scalars['BigInt']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  updated_at?: InputMaybe<Scalars['Datetime']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type UsersUpdateResponse = {
  __typename?: 'usersUpdateResponse';
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars['Int']['output'];
  /** Array of records impacted by the mutation */
  records: Array<Users>;
};

export type ListInstallationRepositoriesQueryVariables = Exact<{
  installationId: Scalars['Int']['input'];
}>;


export type ListInstallationRepositoriesQuery = { __typename?: 'Query', platformsListGithubInstallationRepositories: Array<{ __typename?: 'GithubRepository', id: number, name: string, fullName?: string | null, htmlUrl?: string | null, description?: string | null, private?: boolean | null, fork?: boolean | null, defaultBranch?: string | null, createdAt?: any | null, updatedAt?: any | null, pushedAt?: any | null }> };

export type ListGithubInstallationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListGithubInstallationsQuery = { __typename?: 'Query', platformsListGithubInstallations: Array<{ __typename?: 'Installation', id: number, account: string, accessTokensUrl?: string | null, repositoriesUrl?: string | null, htmlUrl?: string | null, appId?: number | null, targetId?: number | null, targetType?: string | null, events: Array<string>, singleFileName?: string | null, repositorySelection?: string | null, createdAt?: any | null, updatedAt?: any | null }> };

export type ApplyResolutionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  repoId: Scalars['String']['input'];
  resolutionId: Scalars['String']['input'];
}>;


export type ApplyResolutionMutation = { __typename?: 'Mutation', applyResolution: boolean };

export type GetPullRequestQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetPullRequestQuery = { __typename?: 'Query', pull_requestsCollection?: { __typename?: 'pull_requestsConnection', edges: Array<{ __typename?: 'pull_requestsEdge', node: { __typename?: 'pull_requests', provider: any } }> } | null };

export type GetPullRequestIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetPullRequestIdQuery = { __typename?: 'Query', pull_requests_resolutionsCollection?: { __typename?: 'pull_requests_resolutionsConnection', edges: Array<{ __typename?: 'pull_requests_resolutionsEdge', node: { __typename?: 'pull_requests_resolutions', pull_request_id: any } }> } | null };

export type GenerateOpenAiResolutionQueryVariables = Exact<{
  resolutionId: Scalars['UUID']['input'];
  fileIndex: Scalars['Int']['input'];
  model: Scalars['String']['input'];
  temperature: Scalars['Float']['input'];
  maxTokens: Scalars['Int']['input'];
  mergeStrategy: MergeStrategy;
  contextPreferences: AicontextPreferences;
}>;


export type GenerateOpenAiResolutionQuery = { __typename?: 'Query', generateOpenAiResolution: { __typename?: 'MergeResolution', resolved: string, explanation: string } };

export type VerifyOpenAiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type VerifyOpenAiKeysQuery = { __typename?: 'Query', verifyOpenAiKeys: boolean };

export type ListOpenAiModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOpenAiModelsQuery = { __typename?: 'Query', listOpenAiModels: Array<string> };

export type GetResolutionByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetResolutionByIdQuery = { __typename?: 'Query', pull_requests_resolutionsCollection?: { __typename?: 'pull_requests_resolutionsConnection', edges: Array<{ __typename?: 'pull_requests_resolutionsEdge', node: { __typename?: 'pull_requests_resolutions', id: any, hash_id: any, status: string, base_sha: string, head_sha: string } }> } | null };

export type GetConflictResolutionsQueryVariables = Exact<{
  pullRequestId: Scalars['UUID']['input'];
}>;


export type GetConflictResolutionsQuery = { __typename?: 'Query', pull_requests_resolutionsCollection?: { __typename?: 'pull_requests_resolutionsConnection', edges: Array<{ __typename?: 'pull_requests_resolutionsEdge', node: { __typename?: 'pull_requests_resolutions', id: any, status: string, created_at?: any | null, updated_at?: any | null } }> } | null };

export type GetPullRequestIdFromProviderQueryVariables = Exact<{
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
  prNumber: Scalars['Int']['input'];
}>;


export type GetPullRequestIdFromProviderQuery = { __typename?: 'Query', pull_requests_by_providerCollection?: { __typename?: 'pull_requests_by_providerConnection', edges: Array<{ __typename?: 'pull_requests_by_providerEdge', node: { __typename?: 'pull_requests_by_provider', id?: any | null } }> } | null };

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  userData: UsersUpdateInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateusersCollection: { __typename?: 'usersUpdateResponse', affectedCount: number, records: Array<{ __typename?: 'users', id: any, avatar_url?: string | null, user_id?: string | null, emails?: Array<string | null> | null, first_name?: string | null, last_name?: string | null, email_notifications: boolean, email_newsletter: boolean }> } };

export type MergeUserSettingsMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  settings: Scalars['JSON']['input'];
}>;


export type MergeUserSettingsMutation = { __typename?: 'Mutation', merge_user_settings?: any | null };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', usersCollection?: { __typename?: 'usersConnection', edges: Array<{ __typename?: 'usersEdge', node: { __typename?: 'users', id: any, avatar_url?: string | null, settings: any, user_id?: string | null, emails?: Array<string | null> | null, first_name?: string | null, last_name?: string | null, public_repos?: any | null, followers?: any | null, email_notifications: boolean, email_newsletter: boolean, banned: boolean } }> } | null };

export type AddPaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['String']['input'];
}>;


export type AddPaymentMethodMutation = { __typename?: 'Mutation', addPaymentMethod: { __typename?: 'PaymentMethodDetails', id: string, billing: { __typename?: 'BillingAddress', country?: string | null, name?: string | null }, card: { __typename?: 'CardDetails', brand: string, last4: string, expMonth: number, expYear: number, country?: string | null } } };

export type DeleteSlackConnectionMutationVariables = Exact<{
  teamId: Scalars['String']['input'];
}>;


export type DeleteSlackConnectionMutation = { __typename?: 'Mutation', deleteFromslack_connectionsCollection: { __typename?: 'slack_connectionsDeleteResponse', records: Array<{ __typename?: 'slack_connections', nodeId: string, team_id: string }> } };

export type RemovePaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['String']['input'];
}>;


export type RemovePaymentMethodMutation = { __typename?: 'Mutation', removePaymentMethod: { __typename?: 'PaymentMethodDetails', id: string, billing: { __typename?: 'BillingAddress', country?: string | null, name?: string | null }, card: { __typename?: 'CardDetails', brand: string, last4: string, expMonth: number, expYear: number, country?: string | null } } };

export type SchedulePrMutationVariables = Exact<{
  ownerId: Scalars['String']['input'];
  repoId: Scalars['String']['input'];
  pr: Scalars['Int']['input'];
}>;


export type SchedulePrMutation = { __typename?: 'Mutation', schedulePr: boolean };

export type UpdateNotificationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  notificationData: NotificationsUpdateInput;
}>;


export type UpdateNotificationMutation = { __typename?: 'Mutation', updatenotificationsCollection: { __typename?: 'notificationsUpdateResponse', affectedCount: number, records: Array<{ __typename?: 'notifications', id: any, user_id: any, created_at: any, unread: boolean, payload: any }> } };

export type DeleteNotificationsMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteNotificationsMutation = { __typename?: 'Mutation', deleteFromnotificationsCollection: { __typename?: 'notificationsDeleteResponse', affectedCount: number, records: Array<{ __typename?: 'notifications', id: any, user_id: any, created_at: any, unread: boolean, payload: any }> } };

export type GetAuditLogsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAuditLogsQuery = { __typename?: 'Query', auditLogs: { __typename?: 'AuditLogEntryTypeConnection', edges: Array<{ __typename?: 'AuditLogEntryTypeEdge', cursor: string, node: { __typename?: 'AuditLogEntryType', timestamp: any, event: string, status: EntryStatusType, ipAddress?: string | null, details?: string | null, location?: { __typename?: 'LocationType', country?: string | null, city?: string | null, latitude?: number | null, longitude?: number | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetNotificationsQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetNotificationsQuery = { __typename?: 'Query', notificationsCollection?: { __typename?: 'notificationsConnection', totalCount: number, edges: Array<{ __typename?: 'notificationsEdge', node: { __typename?: 'notifications', id: any, user_id: any, created_at: any, unread: boolean, payload: any } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GetSlackConnectionsQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type GetSlackConnectionsQuery = { __typename?: 'Query', slack_connectionsCollection?: { __typename?: 'slack_connectionsConnection', edges: Array<{ __typename?: 'slack_connectionsEdge', node: { __typename?: 'slack_connections', nodeId: string, team_id: string, team_name?: string | null, user_id: any, bot_user_id: string, installed_at?: any | null } }> } | null };

export type GetPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentMethodsQuery = { __typename?: 'Query', listPaymentMethods: Array<{ __typename?: 'PaymentMethodDetails', id: string, billing: { __typename?: 'BillingAddress', country?: string | null, name?: string | null }, card: { __typename?: 'CardDetails', brand: string, last4: string, expMonth: number, expYear: number, country?: string | null } }> };

export type GetPullRequestsResolutionsQueryVariables = Exact<{
  pullRequestId: Scalars['UUID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetPullRequestsResolutionsQuery = { __typename?: 'Query', pull_requests_resolutionsCollection?: { __typename?: 'pull_requests_resolutionsConnection', totalCount: number, edges: Array<{ __typename?: 'pull_requests_resolutionsEdge', node: { __typename?: 'pull_requests_resolutions', id: any, pull_request_id: any, base_sha: string, head_sha: string, metadata?: any | null, status: string, created_at?: any | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };


export const ListInstallationRepositoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListInstallationRepositories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platformsListGithubInstallationRepositories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"installationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"installationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"htmlUrl"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"private"}},{"kind":"Field","name":{"kind":"Name","value":"fork"}},{"kind":"Field","name":{"kind":"Name","value":"defaultBranch"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"pushedAt"}}]}}]}}]} as unknown as DocumentNode<ListInstallationRepositoriesQuery, ListInstallationRepositoriesQueryVariables>;
export const ListGithubInstallationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListGithubInstallations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platformsListGithubInstallations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"}},{"kind":"Field","name":{"kind":"Name","value":"accessTokensUrl"}},{"kind":"Field","name":{"kind":"Name","value":"repositoriesUrl"}},{"kind":"Field","name":{"kind":"Name","value":"htmlUrl"}},{"kind":"Field","name":{"kind":"Name","value":"appId"}},{"kind":"Field","name":{"kind":"Name","value":"targetId"}},{"kind":"Field","name":{"kind":"Name","value":"targetType"}},{"kind":"Field","name":{"kind":"Name","value":"events"}},{"kind":"Field","name":{"kind":"Name","value":"singleFileName"}},{"kind":"Field","name":{"kind":"Name","value":"repositorySelection"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<ListGithubInstallationsQuery, ListGithubInstallationsQueryVariables>;
export const ApplyResolutionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"applyResolution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"repoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resolutionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applyResolution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"repoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"repoId"}}},{"kind":"Argument","name":{"kind":"Name","value":"resolutionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resolutionId"}}}]}]}}]} as unknown as DocumentNode<ApplyResolutionMutation, ApplyResolutionMutationVariables>;
export const GetPullRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPullRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pull_requestsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPullRequestQuery, GetPullRequestQueryVariables>;
export const GetPullRequestIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPullRequestId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pull_requests_resolutionsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pull_request_id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPullRequestIdQuery, GetPullRequestIdQueryVariables>;
export const GenerateOpenAiResolutionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerateOpenAiResolution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resolutionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileIndex"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"temperature"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxTokens"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mergeStrategy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MergeStrategy"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contextPreferences"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AicontextPreferences"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateOpenAiResolution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"resolutionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resolutionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileIndex"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileIndex"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"temperature"},"value":{"kind":"Variable","name":{"kind":"Name","value":"temperature"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxTokens"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxTokens"}}},{"kind":"Argument","name":{"kind":"Name","value":"mergeStrategy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mergeStrategy"}}},{"kind":"Argument","name":{"kind":"Name","value":"contextPreferences"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contextPreferences"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolved"}},{"kind":"Field","name":{"kind":"Name","value":"explanation"}}]}}]}}]} as unknown as DocumentNode<GenerateOpenAiResolutionQuery, GenerateOpenAiResolutionQueryVariables>;
export const VerifyOpenAiKeysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VerifyOpenAiKeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyOpenAiKeys"}}]}}]} as unknown as DocumentNode<VerifyOpenAiKeysQuery, VerifyOpenAiKeysQueryVariables>;
export const ListOpenAiModelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListOpenAiModels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listOpenAiModels"}}]}}]} as unknown as DocumentNode<ListOpenAiModelsQuery, ListOpenAiModelsQueryVariables>;
export const GetResolutionByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResolutionById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pull_requests_resolutionsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hash_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"base_sha"}},{"kind":"Field","name":{"kind":"Name","value":"head_sha"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetResolutionByIdQuery, GetResolutionByIdQueryVariables>;
export const GetConflictResolutionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConflictResolutions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pullRequestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pull_requests_resolutionsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pull_request_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pullRequestId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetConflictResolutionsQuery, GetConflictResolutionsQueryVariables>;
export const GetPullRequestIdFromProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPullRequestIdFromProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"owner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"repo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pull_requests_by_providerCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"owner"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"repo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"repo"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pr_number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prNumber"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPullRequestIdFromProviderQuery, GetPullRequestIdFromProviderQueryVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"usersUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateusersCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedCount"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_notifications"}},{"kind":"Field","name":{"kind":"Name","value":"email_newsletter"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const MergeUserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MergeUserSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"settings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merge_user_settings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"settings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"settings"}}}]}]}}]} as unknown as DocumentNode<MergeUserSettingsMutation, MergeUserSettingsMutationVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar_url"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"emails"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"public_repos"}},{"kind":"Field","name":{"kind":"Name","value":"followers"}},{"kind":"Field","name":{"kind":"Name","value":"email_notifications"}},{"kind":"Field","name":{"kind":"Name","value":"email_newsletter"}},{"kind":"Field","name":{"kind":"Name","value":"banned"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const AddPaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addPaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"paymentMethodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expYear"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>;
export const DeleteSlackConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSlackConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFromslack_connectionsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"atMost"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteSlackConnectionMutation, DeleteSlackConnectionMutationVariables>;
export const RemovePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removePaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"paymentMethodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expYear"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;
export const SchedulePrDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SchedulePr"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"repoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schedulePr"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ownerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"repoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"repoId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pr"}}}]}]}}]} as unknown as DocumentNode<SchedulePrMutation, SchedulePrMutationVariables>;
export const UpdateNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"notificationsUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatenotificationsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedCount"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateNotificationMutation, UpdateNotificationMutationVariables>;
export const DeleteNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFromnotificationsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affectedCount"}},{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteNotificationsMutation, DeleteNotificationsMutationVariables>;
export const GetAuditLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAuditLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<GetAuditLogsQuery, GetAuditLogsQueryVariables>;
export const GetNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"DescNullsLast"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetSlackConnectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSlackConnections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slack_connectionsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodeId"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"bot_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"installed_at"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSlackConnectionsQuery, GetSlackConnectionsQueryVariables>;
export const GetPaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listPaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expYear"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables>;
export const GetPullRequestsResolutionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPullRequestsResolutions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pullRequestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pull_requests_resolutionsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pull_request_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pullRequestId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"DescNullsLast"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pull_request_id"}},{"kind":"Field","name":{"kind":"Name","value":"base_sha"}},{"kind":"Field","name":{"kind":"Name","value":"head_sha"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetPullRequestsResolutionsQuery, GetPullRequestsResolutionsQueryVariables>;